// extracted by mini-css-extract-plugin
export default {"content":"OnlineStore_content__ktVLL"};